import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid';
import React, { Component } from 'react';
import { addURL } from 'redux/actions/url';
import ModalRiwayatIuranBulanan from './modals/showModalRiwayatIuranBulanan';

class RiwayatIuranBulanan extends Component {
    constructor(props) {
        super(props)
        this.participantId = this.props.store.getState().sessionUser ? this.props.store.getState().sessionUser.participantId : 0
        this.dataGridRef = React.createRef()
        this.showModalDetailRef = React.createRef()

        this.columns = [
            {
                type: 'buttons',
                buttons: [
                    'edit',
                    {
                        text: 'Detil',
                        hint: 'Detail',
                        onClick: (e) => {
                            this.showModalDetail(e.row.data)
                        }
                    }
                ]
            },
            {
                dataField: 'id',
                caption: 'Upload ID',
                visible: false
            },
            {
                dataField: 'fileName',
                caption: 'Nama File'
            },
            {
                dataField: 'uploadDate',
                caption: 'Tanggal Upload',
                dataType: 'date',
                format: 'dd MMM yyyy'
            },
            {
                dataField: 'pesertaAmount',
                caption: 'Jumlah Peserta',
                dataType: 'number',
                alignment: 'right'
            },
            {
                dataField: 'iuranTotal',
                caption: 'Total Iuran',
                dataType: 'number',
                format: '#,##0.00',
                alignment: 'right'
            },
            {
                dataField: 'sendBy',
                caption: 'Dikirim Oleh'
            },
            {
                dataField: 'sendDate',
                caption: 'Dikirim Tanggal',
                dataType: 'date',
                format: 'dd MMM yyyy'
            },
            {
                dataField: 'verificationBy',
                caption: 'Diperiksa Oleh'
            },
            {
                dataField: 'verificationDate',
                caption: 'Diperiksa Tanggal',
                dataType: 'date',
                format: 'dd MMM yyyy'
            },
            {
                dataField: 'statusId',
                caption: 'Status',
                lookup: {
                    dataSource: [
                        {
                            id: 1,
                            value: 'Checked'
                        },
                        {
                            id: 2,
                            value: 'Approve'
                        }
                    ],
                    valueExpr: 'id',
                    displayExpr: 'value'
                }
            }
        ]
    }

    componentWillMount() {
        let store = this.props.store;
        store.dispatch(addURL(this.props.location.pathname))
    }

    showModalDetail(data) {
        this.showModalDetailRef.current.show()
        this.showModalDetailRef.current.retrieveData(data)
    }

    refreshDataGrid = () => {
        this.dataGridRef.current.forceRefresh()
    }

    forceRefresh = () => {
        this.dataGridRef.current.forceRefresh(true)
    }

    render() {
        return (
            <div className="container-fluid">
                <h2 className="main-title">Riwayat Iuran Bulanan</h2>

                <DevExpressDataGrid
                    ref={this.dataGridRef}
                    loadAPI={`wp/riwayat-iurans?participantId.equals=${this.participantId}`}
                    insertAPI='-'
                    updateAPI='-'
                    deleteAPI='-'

                    backendserver={process.env.REACT_APP_BACKEND_CORE}
                    remoteOperations={true}

                    useArraySource={false}
                    ArraySourceData={''}

                    allowAdding={false}
                    allowDeleting={false}
                    allowUpdating={false}

                    exportExcel={false}
                    exportFileName={"Riwayat Iuran Bulanan"}
                    allowExportSelectedData={true}
                    selection={"multiple"}

                    showBorders={true}

                    paging={true}
                    defaultPageSize={10}
                    height={'80vh'}

                    //bagian konfigurasi popup saat insert dan edit record
                    popupTitle={'Riwayat Iuran Bulanan'}
                    popupWidth={700} //masukan dalam ukuran pixel
                    popupHeight={500} //masukkan dalam ukuran pixel

                    popupFormLabelLocation='left' //accepted value = top, left, right
                    popupFormMinColWidth={300} // minimum lebar kolom
                    popupFormColCount={3} //jumlah kolom pada form

                    //akhir bagian konfigurasi popup

                    ColumnChooser={true} // set false agar kolom tidak dapat di pindah pindah
                    ColumnFixing={true} // set false agar kolom tidak dapat di freeze

                    FilterRow={true} // set false untuk mematikan fitur filter

                    ColumnConfiguration={this.columns} // taruh konfigurasi kolom disini
                    SummaryConfiguration={this.summary}

                    //contoh konfigurasi kolom
                    //this.columns = [{
                    //    dataField: 'kolom1',
                    //    caption: 'Ini Kolom 1'
                    //}, {
                    //    dataField: 'kolom2',
                    //    caption: 'Ini Kolom 2'
                    //}]
                    // detail konfigurasi dapat dilihat di https://js.devexpress.com/Documentation/ApiReference/UI_Widgets/dxDataGrid/Configuration/columns/

                    store={this.props.store} // jangan di edit edit
                />
                <ModalRiwayatIuranBulanan
                    ref={this.showModalDetailRef}
                    store={this.props.store}
                    forceRefresh={this.forceRefresh}
                />
            </div>
        )
    }
}

export default RiwayatIuranBulanan
